module.exports = __webpack_public_path__ + "static/media/img-songoroo.6a489031.png";